var ENV_HOSTNAME = {
    dev: 'hd-qa71.homedepotdev.com',
    stage: 'hd-qa74.homedepotdev.com',
    prod: 'www.homedepot.com',
};
export var isProd = function () {
    return typeof window !== 'undefined' &&
        window.location.hostname === ENV_HOSTNAME.prod;
};
